import { jwtDecode } from "jwt-decode";
import type { FidexaModulesType } from "./moduleTemplateUtils";

interface JwtPayload {
  unique_name: string;
  nameid: string;
  groupsid: string;
  nbf?: number;
  exp?: number;
  iat?: number;
  modules: string;
  role?: string;
}

function getModules(accessToken: string): FidexaModulesType[] {
  if (accessToken === undefined || accessToken === "" || accessToken === null)
    return [];

  // O produto opera somente com o módulo CHARGE: todo usuário autenticado é
  // tratado como CHARGE, independentemente do que vier no claim `modules`.
  return ["CHARGE"];
}

function getGroupSid(accessToken: string): string | null {
  if (accessToken === undefined || accessToken === "" || accessToken === null)
    return null;

  const decoded = jwtDecode<JwtPayload>(accessToken);

  const payload = decoded.groupsid;
  return payload;
}


function getUserName(accessToken: string): string | null {
  if (accessToken === undefined || accessToken === "" || accessToken === null)
    return null;

  const decoded = jwtDecode<JwtPayload>(accessToken);

  const payload = decoded.unique_name;
  return payload;
}


function getUserId(accessToken: string): string | null {
  if (accessToken === undefined || accessToken === "" || accessToken === null)
    return null;

  const decoded = jwtDecode<JwtPayload>(accessToken);

  const payload = decoded.nameid;
  return payload;
}

function getCookie(name: string) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return decodeURIComponent(match[2]);
  return null;
}

// SHA-256 do texto normalizado (lowercase), em hex. Usado para comparar o
// user_id do token contra uma lista de hashes (evita expor IDs em texto puro
// no bundle/inspect do frontend).
async function hashUserId(userId: string): Promise<string> {
  const normalized = userId.trim().toLowerCase();
  const data = new TextEncoder().encode(normalized);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest))
    .map(byte => byte.toString(16).padStart(2, "0"))
    .join("");
}

export const parseJwtUtils = {
  getGroupSid,
  getCookie,
  getModules,
  getUserName,
  getUserId,
  hashUserId
};
